module.exports = __webpack_public_path__ + "assets/img/1_906_big.670a3710.jpg";